import { publicEnv } from '@/lib/env';
import { EventData } from '@/utils/actions/results/getTournamentEvent';

export const getBracketsAppRedirectURL = (eventData: EventData | undefined | null) => {
  if (!eventData) return '';

  const {
    tournamentId,
    activityId,
    statusId,
    currentSequence,
    bracketFormatId,
    currentSequencePoolId,
    totalPools,
  } = eventData;

  const url = new URL(
    `${publicEnv.NEXT_PUBLIC_BRACKETS_URL}/tournaments/${tournamentId}/events/${activityId}`
  ).toString();

  if (statusId === 3) {
    return `${url}/standings`;
  }

  if (currentSequence > 1 || [1, 2].includes(bracketFormatId)) {
    return `${url}/elimination/${currentSequencePoolId}`;
  }

  if (bracketFormatId === 4 && totalPools > 1) {
    return `${url}/overview`;
  }

  if (bracketFormatId === 4 && totalPools === 1) {
    return `${url}/pools/${currentSequencePoolId}`;
  }

  return `${url}/overview`;
};
